import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';
import { Lock, KeyRound } from 'lucide-react';

const HostessLogin = ({ onLogin }) => {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    const p = pin.trim();
    if (!p) return;
    setLoading(true);
    setError(false);
    try {
      const response = await axios.post('/auth/hostess-login', { pin: p });
      const { access_token, user } = response.data;
      onLogin(user, access_token, true);
    } catch (err) {
      setError(true);
      setPin('');
      toast.error(err.response?.data?.detail || 'Ungültiger PIN');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    // Alphanumerisch, max 32 chars
    const value = e.target.value.replace(/[^A-Za-z0-9]/g, '').slice(0, 32);
    setPin(value);
    setError(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden" data-testid="hostess-login-page">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#e30613]/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#e30613]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="w-full max-w-sm p-6 relative z-10">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#e30613]/20 mb-4">
            <KeyRound className="w-8 h-8 text-[#e30613]" />
          </div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Hostess-Login</h1>
          <p className="text-gray-500 text-sm mt-1">Kölner Haie</p>
        </div>

        <Card className="bg-gray-900 border-gray-800">
          <CardHeader className="text-center">
            <CardTitle className="text-white flex items-center justify-center gap-2">
              <Lock className="w-5 h-5 text-[#e30613]" /> PIN-Zugang
            </CardTitle>
            <CardDescription className="text-gray-400">
              Bitte gib deinen persönlichen PIN ein
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="password"
                autoFocus
                inputMode="text"
                value={pin}
                onChange={handleChange}
                placeholder="PIN"
                className={`text-center text-2xl tracking-widest bg-gray-800 border-gray-700 text-white ${error ? 'border-red-500' : ''}`}
                data-testid="hostess-pin-input"
              />
              {error && (
                <p className="text-sm text-red-500 text-center">Ungültiger PIN</p>
              )}
              <Button
                type="submit"
                disabled={loading || pin.length < 4}
                className="w-full bg-[#e30613] hover:bg-[#c00510] text-white font-medium py-2.5"
                data-testid="hostess-login-submit"
              >
                {loading ? 'Anmelden…' : 'Anmelden'}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-gray-600 mt-6">
          © {new Date().getFullYear()} Kölner Haie · Internes System
        </p>
      </div>
    </div>
  );
};

export default HostessLogin;
